import AnamnesisPhasePage from '../../../components/registry/AnamnesisPhasePage';
import type { PhasePageProps } from '../../../components/registry/RegistryPhaseWorkspace';
import hepatoApi from '../../../api/hepatoApi';

/** Faza 1 — Conștientizare & Anamneză: chestionarul importat + exporturile PDF. */
export default function Faza1Page({ record, patient, status }: PhasePageProps) {
  return (
    <AnamnesisPhasePage
      title="Faza 1 — Conștientizare & Anamneză"
      program="hepato"
      record={record}
      patient={patient}
      status={status}
      downloaders={{
        anamnesis: (formId) => hepatoApi.downloadAnamnesisPdf(formId),
        full: (formId) => hepatoApi.downloadFullPdf(formId),
      }}
    />
  );
}
